import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { Sparkles, Loader2, CheckCircle2, XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function SubscriptionCallback() {
  const [params] = useSearchParams();
  const [state, setState] = useState({ loading: true, ok: false, message: "" });
  const { refresh } = useAuth();
  const nav = useNavigate();

  useEffect(() => {
    const token = params.get("token");
    if (!token) {
      setState({ loading: false, ok: false, message: "Ödeme bilgisi bulunamadı." });
      return;
    }
    api.post("/subscription/callback", { token })
      .then(async () => {
        await refresh();
        setState({ loading: false, ok: true, message: "Aboneliğin aktifleştirildi." });
        setTimeout(() => nav("/panel/abonelik", { replace: true }), 2000);
      })
      .catch((e) => setState({ loading: false, ok: false, message: formatApiError(e) }));
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-zinc-50" data-testid="callback-page">
      <div className="w-full max-w-sm text-center">
        <div className="flex items-center gap-2 mb-8 justify-center">
          <div className="w-8 h-8 rounded-xl bg-[#1E3A8A] flex items-center justify-center">
            <Sparkles className="w-4 h-4 text-white" strokeWidth={2.5} />
          </div>
          <span className="font-display font-bold text-lg tracking-tight">SuperZeka</span>
        </div>
        <div className="rounded-2xl border border-zinc-200 bg-white p-8">
          {state.loading && <>
            <Loader2 className="w-8 h-8 text-[#1E3A8A] animate-spin mx-auto" />
            <h1 className="mt-4 font-display text-xl font-semibold">Ödeme doğrulanıyor…</h1>
          </>}
          {!state.loading && state.ok && <>
            <CheckCircle2 className="w-10 h-10 text-[#10B981] mx-auto" />
            <h1 className="mt-4 font-display text-xl font-semibold">Premium aktif</h1>
            <p className="mt-2 text-sm text-zinc-600">{state.message}</p>
          </>}
          {!state.loading && !state.ok && <>
            <XCircle className="w-10 h-10 text-red-500 mx-auto" />
            <h1 className="mt-4 font-display text-xl font-semibold">Ödeme tamamlanmadı</h1>
            <p className="mt-2 text-sm text-zinc-600">{state.message}</p>
            <Button onClick={() => nav("/panel/abonelik")} className="mt-5 rounded-full">Abonelik sayfasına dön</Button>
          </>}
        </div>
      </div>
    </div>
  );
}
